import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import photo from "../../Assets/Images/photo.png";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { TbLogout2 } from "react-icons/tb";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../Context/AuthContext";
import { useGlobalContext } from "../../Context/GlobalContext";
import { useNavigate } from "react-router-dom";

const NavBar = () => {
  const { flowChangerToken } = useAuthContext();
  const { baseUrl, user, setUser } = useGlobalContext();
  const { navigate } = useNavigate();
  console.log(baseUrl);
  console.log(flowChangerToken);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetch(baseUrl + "user/", {
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        });
         const response = await result.json();
        console.log(response);
        setUser(response);
      } catch (error) {
        console.log("error while fetching user", error);
        setUser(null);
      }
    };
    fetchData();
  }, []);

  const handleProfileDropDown = () => {
    setProfileDropDown(!profileDropdown);
  };
  const [profileDropdown, setProfileDropDown] = useState(false);
  const { setIsAuthenticated } = useAuthContext();
  const handleLogout = () => {
    if (Cookies.get("flowChangerAuthToken")) {
      Cookies.remove("flowChangerAuthToken");
      setIsAuthenticated(false);
    }
  };

  const handleAddClass = () => {
    document.body.classList.toggle("custom-body-class");
  };
  const showDropdown = () => setProfileDropDown(true);
  const hideDropdown = () => setProfileDropDown(false);

  return (
    <div className="top-0 z-10 sticky flex justify-between items-center bg-white shadow-sm px-2 py-[12px] sm:py-[7px] border-b w-[100%] navbar">
      <button onClick={handleAddClass}>
        <MenuIcon className="cancel-icon" />
        <CloseIcon className="hidden menu-icon-navbar" />
      </button>

      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4 mr-7 ml-3">
          <div className="relative client-add">
            <input
              className="px-[10px] py-[4px] pr-[40px] pl-[10px] summary-border rounded-3xl text-[13px] client-add focus-visible:outline-none"
              type="text"
              placeholder="Search...."
            />
            <SearchIcon className="top-[8px] right-[8px] absolute h-8 text-[10px] text-gray-500 newadd2" />
          </div>
        </div>
        <div class="inline-block relative mr-[10px] text-left">
          {/* profile dropdown */}

          <img
            onMouseEnter={showDropdown}
            onClick={handleProfileDropDown}
            class="flex justify-center items-center gap-x-1.5 bg-black hover:bg-gray-900 shadow-sm mr-[10px] p-4 rounded-[120%] ring-1 ring-gray-300 ring-inset w-6 h-10 font-semibold text-sm text-white"
            id="menu-button"
            aria-expanded="true"
            aria-haspopup="true"
            src={photo}
            alt=""
            className="cursor-pointer"
          />

          {profileDropdown && (
            <div
              onMouseEnter={showDropdown}
              onMouseLeave={hideDropdown}
              class="right-0 z-10 absolute bg-[#27004a] shadow-lg mt-2 rounded-md w-56 origin-top-right focus:outline-none"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="menu-button"
              tabindex="-1"
            >
              <div class="p-[10px]" role="none">
                <div
                  class="block text-gray-700 text-sm"
                  role="menuitem"
                  tabindex="-1"
                  id="menu-item-0"
                >
                  <p className="hover:bg-white p-2 rounded-md font-medium text-white hover:text-[#8a25b0]">
                    {user?.name}
                  </p>
                  <p className="hover:bg-white p-2 rounded-md font-medium text-white hover:text-[#8a25b0]">
                    Role - {user?.role}
                  </p>
                </div>
                <a
                  href="/authentication/login"
                  type="submit"
                  class="flex justify-between items-center hover:bg-[white] p-2 rounded-md w-full font-medium text-left text-sm text-white hover:text-[red]"
                  role="menuitem"
                  tabindex="-1"
                  id="menu-item-3"
                  onClick={handleLogout}
                >
                  Log out <TbLogout2 className="hover:text-[red]" />{" "}
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavBar;
